import { useSelector } from 'react-redux';
import { useTitle } from 'react-use';
import { isString, toUpper } from 'lodash';
import {
  selectAppDisplayName,
  selectCompanyName,
} from '@bbkAdminRedux/app/selectors';

const getMetaValue = (name: string): string | undefined =>
  document.querySelector(`meta[name="${name}"]`)?.getAttribute('value') ??
  undefined;

const getLocalDevTitleSuffix = (env?: string): string => {
  if (env !== 'dev') {
    return '';
  }

  const localDevDirectory = BBK_LOCAL_DEV_DIRECTORY.trim();
  return localDevDirectory ? ` | ${localDevDirectory}` : '';
};

const getEnvironmentTitlePrefix = (env?: string): string => {
  if (!env || env === 'prod' || env === 'production') {
    return '';
  }
  return `[${toUpper(env)}] `;
};

const buildPageTitle = (title: string, env?: string): string =>
  `${getEnvironmentTitlePrefix(env)}${title}${getLocalDevTitleSuffix(env)}`;

export const usePageTitle = () => {
  const companyName = useSelector(selectCompanyName);
  const appName = useSelector(selectAppDisplayName);

  const env = getMetaValue('environment');

  let title = 'Chargebee Retention';
  let companyTitle = [companyName, appName].filter(isString);
  if (companyTitle.length === 1) {
    title = companyTitle.join('');
  } else if (companyTitle.length > 1) {
    title = companyTitle.join(' | ');
  }

  title = buildPageTitle(title, env);

  useTitle(title);
};
